<template>
  <div class="container">
    <HeadingOne class="-margin-md">口座情報の登録・変更</HeadingOne>

    <NoticeBox class="-success _mb-sm-20 _mb-md-30">
      <NoticeHeader>
        <h3 class="heading">口座のご登録が完了しました。</h3>
      </NoticeHeader>
    </NoticeBox>

    <BtngroupSingle class="-margin-lg">
      <BtnMain class="-main" router-name="mb001">
        会員さま専用サイトトップへ
      </BtnMain>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";

import HeadingOne from "@/components/heading/HeadingOne";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
export default {
  name: "Tem012",
  components: {
    BtnMain,
    BtngroupSingle,
    NoticeHeader,
    NoticeBox,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "口座情報の登録・変更｜口座情報の登録・変更",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,口座情報",
    });
  },
};
</script>

<style scoped></style>
